import { render, staticRenderFns } from "./IconYear.vue?vue&type=template&id=0b0f8803&"
import script from "./IconYear.vue?vue&type=script&lang=js&"
export * from "./IconYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b0f8803')) {
      api.createRecord('0b0f8803', component.options)
    } else {
      api.reload('0b0f8803', component.options)
    }
    module.hot.accept("./IconYear.vue?vue&type=template&id=0b0f8803&", function () {
      api.rerender('0b0f8803', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconYear.vue"
export default component.exports